import React from "react";

export const Pill: React.FC<{
  label: string;
  color?: "blue" | "green" | "gray";
}> = ({ label, color = "gray" }) => {
  const styles = {
    blue: "bg-blue-50 text-blue-600",
    green: "bg-green-50 text-green-600",
    gray: "bg-gray-100 text-gray-500",
  };
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-medium ${styles[color]}`}
    >
      {label}
    </span>
  );
};
